import img2 from './images/z.jpg';
import img3 from './images/ss3.jpg';
import './css/mycss.css';

export function Carousel() {
    return (
        <div
            id="carouselExample"
            className="carousel slide carousel-container"
            data-bs-ride="carousel"
            data-bs-interval="5000"
        >
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <img src={img3} className="carousel-img" alt="Slide 1" />
                </div>
                <div className="carousel-item">
                    <img src={img2} className="carousel-img" alt="Slide 2" />
                </div>
                
            </div>

            <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExample"
                data-bs-slide="prev"
            >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>

            <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExample"
                data-bs-slide="next"
            >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    );
}
